import React from "react";
import { observer } from "mobx-react";
import { Trans, useTranslation } from "@tecma/i18n";

import { Button } from "@tecma/ds/button";
import { Icon } from "@tecma/ds/icon";
import { Modal } from "@tecma/ds/modal";

import "styles/support-alert.scss";

const SupportAlert = observer(({ isOpen, onCancel, onClose, alertType, jiraKey }) => {
  const { t } = useTranslation();

  const feedback = {
    warning: {
      label: t("businessplatform.support.alert.warning"),
      title: t("businessplatform.support.alert.warning.title"),
      iconName: "exclamation-circle",
      description: (
        <>
          <p>
            <Trans
              i18nKey='businessplatform.support.alert.warning.cancelExplanation'
              components={{ 1: <strong /> }}
            />
          </p>
          <p>
            <Trans
              i18nKey='businessplatform.support.alert.warning.proceedExplanation'
              components={{ 1: <strong /> }}
            />
          </p>
        </>
      ),
    },
    error: {
      label: t("businessplatform.support.alert.error"),
      title: t("businessplatform.support.alert.error.title"),
      iconName: "x-circle",
      description: t("businessplatform.support.alert.error.content"),
    },
    success: {
      label: t("businessplatform.support.alert.success"),
      title: t("businessplatform.support.alert.success.title"),
      iconName: "check-circle",
      description: (
        <>
          <p>
            <Trans
              i18nKey='businessplatform.support.alert.success.content'
              components={{ 1: <strong /> }}
            />
          </p>
          <p>{t("businessplatform.support.alert.success.content2")}</p>
          <p>
            {t("businessplatform.support.alert.ticketNumber")} <strong>{jiraKey}</strong>
          </p>
        </>
      ),
    },
  };

  const currentFeedback = feedback[alertType] ?? feedback.warning;

  return (
    <Modal isOpen={isOpen} onClose={onClose} size='small'>
      <Modal.Header title={currentFeedback.label} onClose={onClose} closeIcon />
      <Modal.Content>
        <div
          className={`support-alert-content support-alert-content--${alertType}`}
          role={alertType === "error" ? "alert" : "status"}
          data-testid='support-alert-content'
        >
          <Icon iconName={currentFeedback.iconName} size='extra-large' aria-hidden='true' />
          <h2>{currentFeedback.title}</h2>
          <div className='support-alert-description'>{currentFeedback.description}</div>
        </div>
      </Modal.Content>
      <Modal.Footer>
        {alertType === "warning" ? (
          <>
            <Button outlined onClick={onClose}>
              {t("businessplatform.support.cancel")}
            </Button>
            <Button onClick={onCancel}>{t("businessplatform.support.proceed")}</Button>
          </>
        ) : (
          <Button onClick={onClose}>
            {t(
              alertType === "success"
                ? "businessplatform.support.ok"
                : "businessplatform.support.close",
            )}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
});

export default SupportAlert;
